import { render, staticRenderFns } from "./cModal.vue?vue&type=template&id=0a20199d"
import script from "./cModal.vue?vue&type=script&lang=ts"
export * from "./cModal.vue?vue&type=script&lang=ts"
import style0 from "./cModal.vue?vue&type=style&index=0&id=0a20199d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports